import { StoreBase } from "../../../base/cutil/StoreBase";
import { FontType } from "./FontData";
export class FontStoreState {
    constructor() {
        this.font = FontType.AKREGULAR;
    }
    copyWith(params) {
        const state = new FontStoreState();
        state.font = params.font ?? this.font;
        return state;
    }
}
export class FontStore extends StoreBase {
    constructor() {
        super(() => new FontStoreState());
        this.fonts = {
            [FontType.AKTIVGROTESK]: { fontFamily: "Ak-Regular" },
            [FontType.AKREGULAR]: { fontFamily: "Ak-Regular" },
            [FontType.LATO]: { fontFamily: "Lato" },
            [FontType.LORA]: { fontFamily: "Lora" },
            [FontType.PLAYFAIR_DISPLAY]: { fontFamily: "Playfair Display" },
            [FontType.RALEWAY]: { fontFamily: "Raleway" },
            [FontType.ROBOTO]: { fontFamily: "Roboto" },
        };
    }
    setFont(font) {
        const newState = this.state.copyWith({ font });
        this.emit(newState);
    }
    get font() {
        return this.state.font;
    }
    get fontDatas() {
        return this.fonts[this.state.font];
    }
}
